import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqhq64vbda: FaireProductEntity = {
  token: "p_jqhq64vbda",
  type: "product",
  name: "Colorful Building Blocks",
  brandToken: "b_v7rb5sedtf",
  brandName: "Le Toy Van, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/3e3e24a7c8939f5b31c5deca2a12e93ae511675861fccc2697a3746ae12c7dc6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c39ab57d81122301a4947e3cd6f650cd78396eabb222627f6c2c35df2b4a2224.jpeg",
    "https://cdn.faire.com/fastly/d59a0f4ccebf61b0b28be22e6e9fde4f33193db4b415af8b8e2b2acf268b4002.jpeg",
    "https://cdn.faire.com/fastly/fde29111dc2d5260eded35132486bfefdf3227659787739262c45660b31b7166.jpeg",
    "https://cdn.faire.com/fastly/1ba26796b275dad67d7aad4e45eaeffb4c7e4b7c35ffbcc989aa83007ac9a04d.jpeg",
    "https://cdn.faire.com/fastly/790087f22f0fe26eb9c39a44a8c965b5eb49208e04fa1195ecd66e0ef4d8881c.jpeg",
    "https://cdn.faire.com/fastly/30a60ec7a127eb592b31f9960af28af5a9124e46870282399e89a5ebe1bc931e.jpeg",
  ],
  priceDollars: 34.98,
  description:
    "A timeless classic. Build an imaginary world with this amazing 60-piece wooden building blocks set. This tactile toy was made for fun. Construct your universe using the brightly coloured chunky wooden play pieces, perfect for small hands to grasp. Complete with a fabric storage bag for easy tidy up & transportation. Great for stimulating imaginations and helps to develop cognitive skills, dexterity and hand-eye coordination.\n\n-Safety tested for ages 12 months+\n-Crafted from solid, sustainable rubberwood\n-Plastic-free toy\n-Decorated with non-toxic, water-based resistant paints",
  tags: [],
  msrpDollars: 69.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:02.027Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
